import React from "react";

function CTAButton({
  variant = "primary",
  children,
  className = "",
  fullWidth = false,
  handleClick,
  to,
  ...otherProps
}) {
  // Determine button classes based on variant
  let buttonClasses =
    "inline-flex items-center justify-center text-[12px] md:text-base font-medium h-[36px] md:h-[50px] rounded-[4px] transition-colors";

  if (variant === "primary") {
    buttonClasses += " bg-[#0060C7] text-white hover:bg-[#0050A8]";
  } else {
    buttonClasses +=
      " bg-white text-[#0060C7] border border-[#0060C7] hover:bg-[#F5F9FF]";
  }

  buttonClasses += " w-[180px] md:w-[230px]";

  if (fullWidth) {
    buttonClasses += "w-full";
  }

  if (className) {
    buttonClasses += " " + className;
  }

  // Handle click: navigate or custom scroll/action
  const onClick = () => {
    if (to) {
      window.open(to, "_blank");
    } else if (handleClick) {
      handleClick();
    }
  };

  return (
    <button
      className={`cursor-pointer ${buttonClasses} font-montserrat`}
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </button>
  );
}

export { CTAButton };
